import { render, staticRenderFns } from "./DemoMovesPopup.vue?vue&type=template&id=7e2424b2&scoped=true"
import script from "./DemoMovesPopup.vue?vue&type=script&lang=ts"
export * from "./DemoMovesPopup.vue?vue&type=script&lang=ts"
import style0 from "./DemoMovesPopup.vue?vue&type=style&index=0&id=7e2424b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2424b2",
  null
  
)

export default component.exports